/**
 * Creator ConversationsHub - now simply imports the unified component
 */
import ConversationsHub from "../../../Pages/Conversations/convoHub";

export default ConversationsHub;